<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24"></a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('emotion_comments')">
        导出
      </a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <!--          <a-divider type="vertical" />-->
          <!--          <a-dropdown>-->
          <!--            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>-->
          <!--            <a-menu slot="overlay">-->
          <!--              <a-menu-item>-->
          <!--                <a @click="handleDetail(record)">详情</a>-->
          <!--              </a-menu-item>-->
          <!--              <a-menu-item>-->
          <!--                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">-->
          <!--                  <a>删除</a>-->
          <!--                </a-popconfirm>-->
          <!--              </a-menu-item>-->
          <!--            </a-menu>-->
          <!--          </a-dropdown>-->
        </span>
      </a-table>
    </div>

    <emotion-comments-modal ref="modalForm" @ok="modalFormOk"></emotion-comments-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import EmotionCommentsModal from './modules/EmotionCommentsModal'
import { mapGetters } from 'vuex'

export default {
  name: 'EmotionCommentsList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    EmotionCommentsModal,
  },
  data() {
    return {
      description: 'emotion_comments管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        // {
        //   title:'student_ement的主键',
        //   align:"center",
        //   dataIndex: 'ementId'
        // },
        // {
        //   title:'评论者id',
        //   align:"center",
        //   dataIndex: 'userId'
        // },
        {
          title: '报备人员名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '报备人员角色',
          align: 'center',
          dataIndex: 'title',
        },
        {
          title: '心情记录',
          align: 'center',
          dataIndex: 'ementScore_dictText',
        },
        {
          title: '详细备注',
          align: 'center',
          dataIndex: 'comment',
        },
        {
          title: '原因分析',
          align: 'center',
          dataIndex: 'specialflag',
        },
        {
          title: '情绪标签',
          align: 'center',
          dataIndex: 'tags',
        },
        // {
        //   title:'创建人ID',
        //   align:"center",
        //   dataIndex: 'createBy'
        // },
        {
          title: '报备时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        // {
        //   title:'更新人ID',
        //   align:"center",
        //   dataIndex: 'updateBy'
        // },
        // {
        //   title:'更新时间',
        //   align:"center",
        //   dataIndex: 'updateTime',
        //   customRender:function (text) {
        //     return !text?"":(text.length>10?text.substr(0,10):text)
        //   }
        // },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align:"center",
        //   fixed:"right",
        //   width:147,
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      url: {
        // list: '/aigoes/schoolWarnRecord/list',
        list: '/rector/moodRecordAndWarnRecord',
        delete: '/aigoes/schoolWarnRecord/delete',
        deleteBatch: '/aigoes/schoolWarnRecord/deleteBatch',
        exportXlsUrl: '/aigoes/schoolWarnRecord/exportXls',
        importExcelUrl: 'aigoes/schoolWarnRecord/importExcel',
      },
      dictOptions: {},
      disableMixinCreated: true,
    }
  },
  created() {
    this.queryParam = {
      type: 0,
      dataType: 2,
      userIdentity: this.identityId,
    }
    this.loadData(1)
  },
  computed: {
    ...mapGetters(['identityId']),
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
